function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoneyBag = function SvgMoneyBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5 20h10c2.6 0 4.5-2.4 3.9-4.9l-1.2-5.3c-.4-1.8-1.5-3.3-3.1-4.3l-2.1-1.3c-.5-.3-.6-1.1-.2-1.6L13.8.8c.4-.3.1-.8-.3-.8h-7c-.4 0-.7.5-.4.9l1.5 1.8c.5.4.4 1.1-.1 1.5L5.4 5.5c-1.5.9-2.6 2.5-3 4.3l-1.2 5.3C.6 17.6 2.5 20 5 20zm5-11c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgMoneyBag;